import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('https://assets.auxodev.dk/')) return url;
  if (url.includes('/cdn-cgi/image/')) return url; // Allerede optimeret
  if (url.toLowerCase().endsWith('.svg')) return url; // Spring SVGs over

  const { width, height, quality = 80, format = 'auto', fit = 'cover' } = options;
  const params = [];
  if (width) params.push(`width=${width}`);
  if (height) params.push(`height=${height}`);
  if (quality) params.push(`quality=${quality}`);
  if (format) params.push(`format=${format}`);
  if (fit && height) params.push(`fit=${fit}`);

  const paramString = params.join(',');
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${paramString}/`);
}
